import React from 'react';
import { history } from 'ice';
import { Icon } from '@b-design/fusion';
import styles from './index.module.less';
import store from '@/store';
import { isPublicDeploy } from '@/utils/config';

const SiteSetting: React.FC = () => {
  const [userState] = store.useModel('user');

  const setting = () => {
    history?.push({
      pathname: '/settings',
    });
  };
  if (isPublicDeploy()) return;

  return (
    <div className={styles.site}>
      {userState?.currentUser?.tenantRole === 'ADMIN' && (
        <Icon type="settings--outline" size="medium" className={styles.setting} onClick={setting} />
      )}
    </div>
  );
};

export default SiteSetting;
